module.exports = __webpack_public_path__ + "img/recovery-hero.5bf078b5.svg";